import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateGradeLevelForm from "../../forms/CreateOrUpdateGradeLevelForm";

interface CreateGradeLevelModalProps {
  open: boolean;
  onClose: () => void;
  loading: boolean;
  error: string | null;
}

const CreateGradeLevelModal: React.FC<CreateGradeLevelModalProps> = ({
  open,
  onClose,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title="Create Grade Level"
    width="sm"
    loading={loading}
  >
    <CreateOrUpdateGradeLevelForm loading={loading} error={error} />
  </AppModal>
);

export default CreateGradeLevelModal;
